import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
  Label,
  Row,
  InputGroupAddon,
  Col,
  CustomInput,
  Input,
  InputGroup,
} from 'reactstrap';
import {
  BtnOutlineRed,
  BtnOutlineGreen,
  BtnModalTable,
  BtnDisabled,
} from '../../styled-components';
import { FormText } from 'reactstrap/lib';
import DateInput from '../../commons/DateInput';

function ActionsField(props) {
  const { onCollectInvoice, data } = props;
  const [t] = useTranslation('CONTACTS');

  const [errors, setErrors] = useState({});
  const [modal, setModal] = useState(false);

  const { payments = [], invoicePinv = {} } = data;
  const invoiceGross = invoicePinv?.total_price?.total || 0;
  const remainderToPay =
    invoiceGross - payments.reduce((acc, val) => acc + val.gross, 0);
  const [gross, setGross] = useState(
    invoiceGross - remainderToPay == 0
      ? Number(invoiceGross.toFixed(2))
      : Number(remainderToPay.toFixed(2))
  );

  const [collectedDate, setCollectedDate] = useState(
    data?.sailInvoice?.collectedDate || undefined
  );
  const [type, setType] = useState('');

  const toggle = () => {
    setModal(!modal);
    setCollectedDate(undefined);
    setErrors({});
  };

  const onAddPaymentSubmit = (e) => {
    e.preventDefault();

    if (!collectedDate || !type || !gross) {
      const errors = {};
      errors.collectedDate = !collectedDate;
      errors.type = !type;
      errors.gross = !gross;
      return setErrors(errors);
    }

    const { payments = [] } = data;
    const alreadyPaid = payments.reduce((acc, { gross = 0 }) => acc + gross, 0);
    const notPaid = Number((invoiceGross - alreadyPaid - gross).toFixed(2));

    onCollectInvoice({
      invoice: {
        ...data,
        sailInvoice: {
          ...data.sailInvoice,
          gross,
          type,
          collectedDate,
          notPaid,
          collected: notPaid === 0,
        },
      },
    });

    setCollectedDate('');
    setType('');
    setGross(notPaid.toFixed(2));
    setErrors({});
    toggle();
  };

  return (
    <React.Fragment>
      <div className="flex-check">
        {!!data?.sailInvoice?.collectedDate ||
        !['Consegnata', 'MancataConsegna'].includes(
          data?.invoicePinv?.einvoice?.status
        ) ? (
          <BtnDisabled type="button" disabled={true}>
            Incassa
          </BtnDisabled>
        ) : (
          <BtnModalTable
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              toggle();
            }}
            disabled={
              !!data?.sailInvoice?.collectedDate ||
              !['Consegnata', 'MancataConsegna'].includes(
                data?.invoicePinv?.einvoice?.status
              )
            }
          >
            Incassa
          </BtnModalTable>
        )}
      </div>

      <Modal isOpen={modal} toggle={toggle} className="payment-sail-invoice">
        <ModalHeader toggle={toggle}>{t('PAGES:COLLECT_INVOICE')}</ModalHeader>
        <Form onSubmit={onAddPaymentSubmit}>
          <ModalBody>
            <div className="max-width-form">
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label>{t('IMPORT_TYPE')} *</Label>
                    <CustomInput
                      type="select"
                      id="type"
                      name="customSelect"
                      onChange={(e) => setType(e.target.value)}
                    >
                      <option value="">{t('IMPORT_TYPE_PLACEHOLDER')}</option>
                      <option value="TRANSFER">{t('TRANSFER')}</option>
                      <option value="CARD">{t('CARD')}</option>
                      <option value="RIBA">{t('RIBA')}</option>
                      <option value="CASH">{t('CASH')}</option>
                      <option value="OTHER">{t('OTHER')}</option>
                    </CustomInput>
                    {errors.type && (
                      <FormText className="error-message">
                        {t('COMMON:REQUIRED')}
                      </FormText>
                    )}
                  </FormGroup>
                </Col>

                <Col xs="12">
                  <FormGroup>
                    <Label>{t('IMPORT')} *</Label>
                    <InputGroup>
                      <Input
                        type="number"
                        name="gross"
                        placeholder="0.00"
                        step="0.01"
                        value={gross}
                        max={remainderToPay < 0 ? 0 : remainderToPay.toFixed(2)}
                        onChange={({ target }) => {
                          if (/^-?[\d]*\.?[\d]{0,2}$/.test(target.value)) {
                            setGross(target.value);
                          }
                        }}
                      />
                      <InputGroupAddon addonType="prepend">€</InputGroupAddon>
                    </InputGroup>
                    {errors.gross && (
                      <FormText className="error-message">
                        {t('COMMON:REQUIRED')}
                      </FormText>
                    )}
                  </FormGroup>
                </Col>

                <Col xs="12">
                  <FormGroup>
                    <div>
                      <Label>{t('RECEIPT_DATE')} *</Label>
                    </div>
                    <DateInput
                      name="collectedDate"
                      value={collectedDate}
                      setMidday
                      returnDateObject
                      onChange={(date) => {
                        setCollectedDate(date);
                      }}
                      disablePopup
                    />
                    {errors.collectedDate && (
                      <FormText className="error-message">
                        {t('COMMON:REQUIRED')}
                      </FormText>
                    )}
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </ModalBody>
          <ModalFooter>
            <BtnOutlineRed type="button" className="uppercase" onClick={toggle}>
              {t('COMMON:CANCEL')}
            </BtnOutlineRed>
            <BtnOutlineGreen type="submit" className="uppercase">
              {t('COMMON:CONFIRM')}
            </BtnOutlineGreen>
          </ModalFooter>
        </Form>
      </Modal>
    </React.Fragment>
  );
}

export default ActionsField;
